import { MemberType } from "src/types";
import { cleanAndCapitalize } from "./useCompanyStaff";
import { QueryClient, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { logEnvironment } from "@components/lib/utils";
import { getClientDomain } from "./useFetchUnits";

export type RawDirector = {
  id: number;
  name: string;
  title: string;
  tier: number;
  professional_title: string;
  role: string;
  email: string;
  phone: string;
  username: string | null;
  picture: string;
  address: string | null;
  user_id: number;
  company_id: number;
};

export async function fetchDirectors(
  listingIdentifier: string
): Promise<MemberType[]> {
  const url = `${process.env.NEXT_PUBLIC_BASE_URL}api/v1/custom/company-directors/${listingIdentifier}`;
  const response = await axios.get<{ directors: RawDirector[] }>(url);
  const directors = response.data.directors;
  return directors.map((staff) => ({
    id: staff.user_id,
    name: cleanAndCapitalize(`${staff.title} ${staff.name}`),
    title: staff.title,
    estateTitle: "",
    role: staff.professional_title,
    email: staff.email,
    phone: staff.phone,
    is_verified: staff.tier === 2,
    username: staff.username,
    image: staff.picture,
    userId: staff.user_id,
    branch: "",
    companyId: staff.company_id,
  }));
}

export function useDirectors() {
  const listingIdentifier = getClientDomain();
  logEnvironment("this the fetch directors componennt");

  return useQuery<MemberType[]>({
    queryKey: ["companyDirectors"],
    queryFn: () => fetchDirectors(listingIdentifier!),
    enabled: !!listingIdentifier,
    staleTime: 5 * 60 * 1000,
  });
}

export async function prefetchDirectors(
  queryClient: QueryClient,
  listingIdentifier: string
) {
  await queryClient.prefetchQuery<MemberType[]>({
    queryKey: ["companyDirectors"],
    queryFn: () => fetchDirectors(listingIdentifier),
    staleTime: 5 * 60 * 1000,
  });
}
